import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import _get from "lodash/get";
import _find from "lodash/find";
var _excluded = ["text"];
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.array.includes.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import { useEffect, useRef, useState } from 'react';
import classnames from 'classnames';
import { AddonCard } from "../AddonCard/AddonCard";
import { AddonToggle } from "../AddonToggle/AddonToggle";
import { Button } from "../../Button/Button/Button";
import { ChangeDurationItem } from "../ChangeDurationItem/ChangeDurationItem";
import { Text } from "../../Text/Text/Text";
import { Breakpoints } from "../../Responsive/Breakpoints/Breakpoints";
import Browser from "../../Utility/Browser";
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Pagination } from 'swiper';
import 'swiper/swiper.min.css';
import styles from "./ChangeDuration.module.scss";
import { MatchHeight } from "../../Utility/MatchHeight/MatchHeight";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var ChangeDuration = function ChangeDuration(_ref) {
  var _ref$headline = _ref.headline,
    headline = _ref$headline === void 0 ? '' : _ref$headline,
    _ref$headlineTypog = _ref.headlineTypog,
    headlineTypog = _ref$headlineTypog === void 0 ? 'subhead1' : _ref$headlineTypog,
    _ref$defaultItemName = _ref.defaultItemName,
    defaultItemName = _ref$defaultItemName === void 0 ? '' : _ref$defaultItemName,
    _ref$items = _ref.items,
    items = _ref$items === void 0 ? [] : _ref$items,
    cta = _ref.cta,
    _ref$version = _ref.version,
    version = _ref$version === void 0 ? 'default' : _ref$version,
    _ref$mobileCarousel = _ref.mobileCarousel,
    mobileCarousel = _ref$mobileCarousel === void 0 ? false : _ref$mobileCarousel,
    _ref$onChange = _ref.onChange,
    onChange = _ref$onChange === void 0 ? function () {} : _ref$onChange,
    _ref$addonsBlock = _ref.addonsBlock,
    addonsBlock = _ref$addonsBlock === void 0 ? {
      headline: '',
      headlineTypog: 'subhead2',
      description: '',
      addonCards: []
    } : _ref$addonsBlock,
    addonToggle = _ref.addonToggle,
    simplifiedCards = _ref.simplifiedCards;
  var firstUpdate = useRef(true);
  var defaultItem = _find(items, function (item) {
    return item.name === defaultItemName;
  });
  var defaultItemValue = _get(defaultItem, 'value');
  var flagItem = _find(items, function (item) {
    return item.flag;
  });
  var flagItemValue = _get(flagItem, 'value');
  var firstItemValue = _get(items, '[0].value');
  var _useState = useState('desktop'),
    _useState2 = _slicedToArray(_useState, 2),
    screenWidth = _useState2[0],
    setScreenWidth = _useState2[1];

  // If there is an item with a flag, set it as default selected.
  // If not, set the first item as default selected.
  var _useState3 = useState(defaultItemValue || flagItemValue || firstItemValue || ''),
    _useState4 = _slicedToArray(_useState3, 2),
    option = _useState4[0],
    setOption = _useState4[1];

  // If data for the first item has changed (ex. plan changes dynamically),
  // Or the default value has changed,
  // If there is a new item with a flag, set it as selected.
  // If not, set the first new item as selected.
  useEffect(function () {
    if (firstUpdate.current) {
      firstUpdate.current = false;
      return;
    }
    var hasFlag = -1;
    var newValue = defaultItemValue || '';
    if (!defaultItemValue) {
      hasFlag = 1;
      newValue = firstItemValue;
    }
    if (hasFlag > -1) {
      newValue = flagItemValue;
    }
    setOption(newValue);
    if (onChange) {
      onChange(newValue);
    }
  }, [defaultItemName, defaultItemValue, firstItemValue, flagItemValue, onChange]);
  var onDurationChange = function onDurationChange(option) {
    setOption(option);
    if (onChange) {
      onChange(option);
    }
  };
  var renderCTA = function renderCTA() {
    var _ref2 = cta || {},
      text = _ref2.text,
      otherProps = _objectWithoutProperties(_ref2, _excluded);
    return text && /*#__PURE__*/_jsx(Button, _objectSpread(_objectSpread({
      type: "primary"
    }, otherProps), {}, {
      children: text
    }));
  };
  useEffect(function () {
    onScreenResize();
    if (Browser.isBrowser()) {
      // Component mount.
      window.addEventListener('resize', onScreenResize);
      // Component unmount.
      return function () {
        window.removeEventListener('resize', onScreenResize);
      };
    }
  }, []);
  var onScreenResize = function onScreenResize() {
    if (window.innerWidth <= Breakpoints.mobile.max) {
      setScreenWidth('mobileSm');
    } else if (window.innerWidth <= Breakpoints.tablet.min) {
      setScreenWidth('mobileLg');
    } else {
      setScreenWidth('desktop');
    }
  };
  var onRealIndexChange = function onRealIndexChange(el) {
    var item = items && items[el.activeIndex];
    if (!!(item !== null && item !== void 0 && item.value)) {
      onChange(item.value);
    }
  };
  var renderSwiper = function renderSwiper(screenWidth) {
    var slidesPerView = screenWidth === 'mobileSm' || simplifiedCards ? 1 : 1.25;
    return /*#__PURE__*/_jsx(MatchHeight, {
      children: /*#__PURE__*/_jsx(Swiper, {
        slidesPerView: slidesPerView,
        spaceBetween: 30,
        pagination: {
          clickable: true
        },
        onRealIndexChange: onRealIndexChange,
        children: items === null || items === void 0 ? void 0 : items.map(function (item, index) {
          return /*#__PURE__*/_jsx(SwiperSlide, {
            children: function children(_ref3) {
              var isActive = _ref3.isActive;
              return /*#__PURE__*/_jsx(ChangeDurationItem, _objectSpread(_objectSpread({}, item), {}, {
                valueSelected: isActive ? item.name : '',
                onChange: onDurationChange,
                wrapperClass: classnames({
                  [styles["items-".concat(items.length)]]: items && styles["items-".concat(items.length)]
                }),
                version: version,
                mobileCarousel: true,
                addonToggle: addonToggle,
                simplifiedCards: simplifiedCards
              }), "change-duration-".concat(index));
            }
          }, index);
        })
      })
    });
  };
  SwiperCore.use([Pagination]);
  var addonsHeadlineTypog = addonsBlock.headlineTypog ? addonsBlock.headlineTypog : 'subhead2';
  var wrapperClassName = simplifiedCards ? classnames(styles.wrapperV6) : version === 'V4' || version === 'V5' ? styles.wrapperV4 : styles.wrapper;
  var buttonClassName = simplifiedCards ? classnames(styles.button, styles.buttonV6) : version === 'V4' ? classnames(styles.button, styles.buttonV4) : styles.button;
  return /*#__PURE__*/_jsxs("div", {
    children: [headline && /*#__PURE__*/_jsx(Text, {
      typog: headlineTypog,
      children: headline
    }), /*#__PURE__*/_jsxs("div", {
      className: wrapperClassName,
      children: [mobileCarousel && screenWidth !== 'desktop' && renderSwiper(screenWidth), (!mobileCarousel || mobileCarousel && screenWidth === 'desktop') && (items === null || items === void 0 ? void 0 : items.map(function (item, index) {
        return /*#__PURE__*/_jsx(ChangeDurationItem, _objectSpread(_objectSpread({}, item), {}, {
          valueSelected: option,
          onChange: onDurationChange,
          wrapperClass: classnames({
            [styles["items-".concat(items.length)]]: items && styles["items-".concat(items.length)]
          }),
          version: version,
          simplifiedCards: simplifiedCards
        }), "change-duration-".concat(index));
      }))]
    }), addonToggle && /*#__PURE__*/_jsx("div", {
      className: classnames(styles.addonToggleContainer, mobileCarousel && styles.withCarousel),
      children: /*#__PURE__*/_jsx(AddonToggle, _objectSpread({}, addonToggle))
    }), addonsBlock && /*#__PURE__*/_jsxs("div", {
      className: styles.addonsBlock,
      children: [addonsBlock.headline && /*#__PURE__*/_jsx(Text, {
        typog: addonsHeadlineTypog,
        className: styles.addonsBlockHeadline,
        children: addonsBlock.headline
      }), addonsBlock.description && /*#__PURE__*/_jsx(Text, {
        typog: "bodycopy",
        className: styles.addonsBlockDescription,
        children: addonsBlock.description
      }), addonsBlock.addonCards && addonsBlock.addonCards.map(function (addonCard, index) {
        return /*#__PURE__*/_jsx(AddonCard, _objectSpread({}, addonCard), "addon-".concat(index));
      })]
    }), ['default', 'V1', 'V4', 'V5'].includes(version) && /*#__PURE__*/_jsx("div", {
      className: buttonClassName,
      children: renderCTA()
    })]
  });
};